import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { menuData } from '../data/menuData';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { ScrollArea, ScrollBar } from './ui/scroll-area';

const menuImages = [
  'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/pyo905q8_WhatsApp%20Image%202026-04-17%20at%2012.21.49.jpeg',
  'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/hp2qtrai_WhatsApp%20Image%202026-04-17%20at%2012.21.49%20%282%29.jpeg',
  'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/6ipvd03w_WhatsApp%20Image%202026-04-17%20at%2012.21.50.jpeg',
  'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/37q7rn4i_WhatsApp%20Image%202026-04-17%20at%2012.21.51%20%281%29.jpeg',
  'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/7aqepkza_WhatsApp%20Image%202026-04-17%20at%2012.21.51%20%282%29.jpeg',
  'https://customer-assets.emergentagent.com/job_ruis-steakhouse/artifacts/zuikrzqv_WhatsApp%20Image%202026-04-17%20at%2012.21.49%20%281%29.jpeg',
];

export default function MenuSection() {
  const { language, t } = useLanguage();

  const categories = [
    { key: 'starters', label: t('menu.categories.starters') },
    { key: 'steaks', label: t('menu.categories.steaks') },
    { key: 'lamb', label: t('menu.categories.lamb') },
    { key: 'fish', label: t('menu.categories.fish') },
    { key: 'chicken', label: t('menu.categories.chicken') },
    { key: 'pasta', label: t('menu.categories.pasta') },
    { key: 'vegetarian', label: t('menu.categories.vegetarian') },
    { key: 'burgers', label: t('menu.categories.burgers') },
    { key: 'kids', label: t('menu.categories.kids') },
    { key: 'extras', label: t('menu.categories.extras') },
  ];

  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="section-padding bg-[#F0EAE1]"
    >
      <div className="section-container">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="overline mb-4">{t('menu.overline')}</p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-medium text-[#2A1E17]">
            {t('menu.title')}
          </h2>
          <div className="w-20 h-[2px] bg-[#8C5A2B] mx-auto mt-6" />
        </div>

        {/* Menu Images Grid - 6 photos */}
        <div className="mb-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {menuImages.map((img, index) => (
            <div key={index} className="overflow-hidden">
              <img
                src={img}
                alt={`Menu dish ${index + 1}`}
                className="w-full h-[150px] md:h-[180px] object-cover hover:scale-110 transition-transform duration-500"
              />
            </div>
          ))}
        </div>

        {/* Menu Tabs */}
        <Tabs defaultValue="starters" className="w-full">
          <ScrollArea className="w-full whitespace-nowrap mb-12">
            <TabsList className="inline-flex w-full justify-start md:justify-center gap-2 bg-transparent p-0 h-auto">
              {categories.map((cat) => (
                <TabsTrigger
                  key={cat.key}
                  value={cat.key}
                  data-testid={`menu-tab-${cat.key}`}
                  className="px-4 py-3 text-sm font-medium uppercase tracking-wide text-[#6B584B] bg-transparent border-b-2 border-transparent data-[state=active]:border-[#8C5A2B] data-[state=active]:text-[#2A1E17] rounded-none transition-all hover:text-[#2A1E17]"
                >
                  {cat.label}
                </TabsTrigger>
              ))}
            </TabsList>
            <ScrollBar orientation="horizontal" />
          </ScrollArea>

          {categories.map((cat) => (
            <TabsContent
              key={cat.key}
              value={cat.key}
              data-testid={`menu-content-${cat.key}`}
              className="mt-0"
            >
              <div className="max-w-3xl mx-auto space-y-0">
                {menuData[cat.key]?.map((item, index) => (
                  <div
                    key={index}
                    className="py-5 border-b border-[#E6D8C8] last:border-b-0"
                  >
                    <div className="flex justify-between items-start gap-4">
                      <div className="flex-1">
                        <h3 className="font-['Cormorant_Garamond'] text-xl md:text-2xl font-medium text-[#2A1E17]">
                          {item.name[language]}
                        </h3>
                        {item.description[language] && (
                          <p className="text-[#6B584B] text-sm mt-1">
                            {item.description[language]}
                          </p>
                        )}
                      </div>
                      <span className="font-['Cormorant_Garamond'] text-xl font-medium text-[#8C5A2B] whitespace-nowrap">
                        {item.price}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </section>
  );
}
